<idp-footer-ui
  *ngIf="
    footerFacadeService.loaded && footerFacadeService.darkSiteLevel !== 'level0'
  "
  [contentFooter]="
    (footerFacadeService.headerFooterDetails$ | ngrxPush) || emptyFooterContent
  "
  [displaySearch]="displaySearch"
  [disableLangSelection]="disableLangSelection"
  [isLightFooter]="isLightFooter"
  [disableBackgroundColor]="disableBackgroundColor"
  [trimFooter]="trimFooter"
  (afterViewCheck)="afterViewCheckEvent()"
  (iconClick)="iconClick($event)"
  (search)="search($event)"
  (searchAnalyticsEvent)="onSearchAnalytics($event)"
  (searchInputAnalyticsEvent)="onSearchInputAnalytics($event)"
  (analyticsEvent)="analyticsCall($event)"
></idp-footer-ui>
